const convertToBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = () => {
      try {
        if (!reader.result) {
          return reject(new Error('FileReader result is null'))
        }

        return resolve(reader.result.toString().split(',')[1])
      } catch (error) {
        return reject(error)
      }
    }
    reader.onerror = (error) => reject(error)
  })

export default convertToBase64
